import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './styles/index.scss';
import './i18n/index';
import { unstable_HistoryRouter as UnstableHistoryRouter, useRoutes } from 'react-router-dom';
import { initialize } from './actions';
import { paths } from './constants';
import Consent from './features/consentPage/Consent';
import LandingPage from './features/landing/LandingPage';
import NotSupported from './features/landing/NotSupported';
import LoginView from './features/LoginViews/LoginView';
import SingleSignOnView from './features/LoginViews/SingleSignOnView';
import RegisterView from './features/registerUser/RegisterView';
import SendConfirmationCodeView from './features/registerUser/SendConfirmationCodeView';
import VerifyUserView from './features/registerUser/VerifyUserView';
import ResetPassword from './features/ResetPassword/ResetPassword';
import SsoConsentView from './features/ssoValidation/SsoTermsView';
import ValidationPage from './features/ssoValidation/ValidationPage';
import reportWebVitals from './reportWebVitals';
import configureStore from './store/configureStore';
import history from './store/history';

const store = configureStore();
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
store.dispatch(initialize());

const router = [
    { path: '/', element: <LandingPage /> },
    { path: paths.login, element: <LoginView /> },
    { path: paths.registration, element: <RegisterView /> },
    { path: paths.verify, element: <VerifyUserView /> },
    { path: paths.resendConfirmationCode, element: <SendConfirmationCodeView /> },
    { path: paths.resetPassword, element: <ResetPassword /> },
    { path: paths.authorizePath, element: <Consent /> },
    { path: paths.notSupported, element: <NotSupported /> },
    { path: paths.singleSignOnLogin, element: <SingleSignOnView /> },
    { path: paths.singleSignOnValidation, element: <ValidationPage /> },
    { path: paths.singleSignOnTAndC, element: <SsoConsentView /> },
];

const AccountRoutes = (): JSX.Element | null => {
    return useRoutes(router);
};

const App = (): React.ReactElement => {
    return (
        <Provider store={store}>
            <UnstableHistoryRouter history={history}>
                <AccountRoutes />
            </UnstableHistoryRouter>
        </Provider>
    );
};

createRoot(document.getElementById('root') as HTMLElement).render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
